import photosTemplate from '../templates/photos.html';

/* @ngInject */
function productViewItemDirective(productViewService, $parse) {
  return {
    restrict: 'A',
    require: {
      productViewMode: '?^productViewMode',
      productViewItem: 'productViewItem'
    },
    controller: 'ProductViewItemCtrl',
    controllerAs: 'productViewItem',
    bindToController: true,
    scope: true,
    link(scope, element, attrs, ctrls) {
      const productViewItemCtrl = ctrls.productViewItem;
      let timerHover;
      if (attrs.offer != null) {
        productViewItemCtrl.offer = $parse(attrs.offer)(scope);
      }
      if (attrs.onChangeColor != null) {
        productViewItemCtrl.onChangeColor = attrs.onChangeColor;
      }
      if (attrs.maxPhotoView != null) {
        productViewItemCtrl.maxPhotoView = parseFloat(attrs.maxPhotoView);
      }
      if (attrs.onlyPhotoWithColor != null) {
        productViewItemCtrl.onlyPhotoWithColor = attrs.onlyPhotoWithColor === 'true';
      }
      productViewItemCtrl.offerId = attrs.offerId != null && attrs.offerId.length > 0 ? $parse(attrs.offerId)(scope) : null;

      //productViewItemCtrl.getOffersProduct(productViewItemCtrl.productId);

      productViewService.addCallback('setView', viewMode => {
        productViewItemCtrl.viewName = viewMode.viewName;
        setTimeout(() => {
          const colorsViewerCarousel = productViewItemCtrl.getControl('colorsViewerCarousel');
          if (colorsViewerCarousel != null) {
            colorsViewerCarousel.update();
          }
          scope.$digest();
        }, 50);
      });
      element[0].addEventListener('mouseenter', () => {
        if (timerHover != null) {
          clearTimeout(timerHover);
        }
        timerHover = setTimeout(async () => {
          await productViewItemCtrl.enter();
          // eslint-disable-next-line require-atomic-updates
          productViewItemCtrl.isLoad = true;
          scope.$digest();
        }, 100);
      });
      element[0].addEventListener('mouseleave', () => {
        clearTimeout(timerHover);
        productViewItemCtrl.leave();
        scope.$digest();
      });
      element[0].addEventListener('touchstart', () => {
        //await productViewItemCtrl.enter();
        productViewItemCtrl.isLoad = true;
        scope.$digest();
      }, {
        passive: true
      });

      //windowService.addCallback('touchstart', function (eventObj) {
      //    var isClickedMe = domService.closest(eventObj.event.target, element[0]) != null;

      //    if (isClickedMe === false) {
      //        productViewItemCtrl.leave();

      //        scope.$digest();
      //    }
      //});
    }
  };
}
productViewItemDirective.$inject = ["productViewService", "$parse"];
function productViewCarouselPhotosDirective() {
  return {
    require: ['^productViewCarouselPhotos', '^productViewItem'],
    restrict: 'A',
    scope: {
      photoHeight: '@',
      photoWidth: '@',
      changePhoto: '&'
    },
    replace: true,
    templateUrl: photosTemplate,
    controller: 'ProductViewCarouselPhotosCtrl',
    controllerAs: 'photosCarousel',
    bindToController: true,
    link(_scope, _element, _attrs, ctrl) {
      const carouselPhotosCtrl = ctrl[0],
        productViewItemCtrl = ctrl[1];
      carouselPhotosCtrl.parentScope = productViewItemCtrl;
      productViewItemCtrl.addControl('photosCarousel', carouselPhotosCtrl);
    }
  };
}

/* @ngInject */
function productViewChangeModeDirective(productViewService, viewList) {
  return {
    restrict: 'A',
    scope: true,
    controller: 'ProductViewChangeModeCtrl',
    controllerAs: 'changeMode',
    bindToController: true,
    link(_scope, _element, attrs, ctrl) {
      ctrl.name = attrs.name;
      ctrl.currentViewList = viewList[attrs.viewListName || 'desktop'];
      ctrl.isMobile = attrs.isMobile === 'true';
      ctrl.isReadyViewMode = false;
      ctrl.defaultViewMode = attrs.defaultViewMode;
      if (ctrl.isMobile === true) {
        ctrl.current = productViewService.getViewFromCookie('mobile_viewmode', ctrl.currentViewList, ctrl.defaultViewMode);
      } else {
        ctrl.current = attrs.viewMode;
      }
      ctrl.isReadyViewMode = true;
    }
  };
}
productViewChangeModeDirective.$inject = ["productViewService", "viewList"];
function productViewModeDirective() {
  return {
    restrict: 'A',
    scope: true,
    require: {
      productViewMode: 'productViewMode'
    },
    controller: 'ProductViewModeCtrl',
    controllerAs: 'productViewMode',
    bindToController: true
  };
}
function productViewImageListDirective() {
  return {
    restrict: 'A',
    scope: true,
    require: {
      productViewMode: '?^productViewMode',
      productViewImageList: 'productViewImageList',
      productViewItem: '^^productViewItem'
    },
    controller: 'ProductViewImageListCtrl',
    controllerAs: 'productViewImageList',
    bindToController: true,
    link(_scope, element, _attrs, ctrls) {
      const productViewImageList = ctrls.productViewImageList;
      let timerHover;
      const loadPhotos = () => {
        if (productViewImageList.limitPhotoCount <= 1) return;
        productViewImageList.insertHtml();
        productViewImageList.getPhotos().then(() => {
          productViewImageList.filterPhotos({
            isVisible: true,
            colorId: productViewImageList.currentColorId,
            onlyColorPhoto: productViewImageList.lastOnlyColorPhoto
          });
        });
      };
      element[0].addEventListener('mouseenter', () => {
        if (productViewImageList.limitPhotoCount <= 1) return;
        if (timerHover != null) {
          clearTimeout(timerHover);
        }
        timerHover = setTimeout(loadPhotos, 100);
      });
      element[0].addEventListener('mouseleave', () => {
        clearTimeout(timerHover);
      });
      element[0].addEventListener('touchstart', loadPhotos, {
        passive: true
      });
    }
  };
}
function productViewImageDirective() {
  return {
    restrict: 'A',
    scope: true,
    require: {
      productViewMode: '?^^productViewMode',
      productViewImageList: '?^productViewImageList',
      productViewImage: 'productViewImage'
    },
    // require: ['?^^productViewMode',
    //     '^^productViewImageList',
    //     'productViewImage'],
    controller: 'ProductViewImageCtrl',
    controllerAs: 'productViewImage',
    bindToController: true
  };
}
function productViewScrollPhotosDirective() {
  return {
    restrict: 'A',
    scope: true,
    require: {
      productViewItem: '^productViewItem'
    },
    controller: ['$element', function ($element) {
      // eslint-disable-next-line no-invalid-this
      const ctrl = this;
      ctrl.$onInit = function () {
        ctrl.productViewItem.addControl('productViewScrollPhotos', ctrl);
      };
      ctrl.scrollToStart = function () {
        $element[0].scrollTo(0, 0);
      };
    }],
    controllerAs: 'productViewScrollPhotos',
    bindToController: true
  };
}
export { productViewItemDirective, productViewCarouselPhotosDirective, productViewChangeModeDirective, productViewModeDirective, productViewScrollPhotosDirective, productViewImageListDirective, productViewImageDirective };